export const DEFAULT_PROFILE_PICTURE = '/assets/default-profile.png'; 